/*
  Weiches Scrollen — Lenis-Anbindung.

  Lenis interpoliert die ECHTE Scroll-Position (kein transformierter
  Wrapper). Dadurch funktionieren position:sticky, IntersectionObserver
  und Sprungmarken unverändert weiter.

  Drei Dinge, die hier bewusst geregelt sind:
  1. Bei "Bewegung reduzieren" bleibt es komplett aus.
  2. Auf Touch-Geräten bleibt der native Schwung erhalten — nachgebauter
     Touch-Schwung fühlt sich auf iOS immer falsch an.
  3. Sobald ein Overlay das Scrollen sperrt (Warenkorb-Drawer der App,
     Menü, Dialog), wird Lenis angehalten. Ohne das scrollt die Seite
     hinter dem offenen Drawer weiter.
*/
(() => {
  const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduziert.matches) return;
  // Touch behält ohnehin den nativen Schwung (syncTouch: false). Lenis würde
  // dort nur eine Dauerschleife pro Bild laufen lassen, ohne etwas zu bewirken.
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (document.body.dataset.motion !== 'an') return;
  if (typeof window.Lenis !== 'function') return;

  const lenis = new window.Lenis({
    duration: 1.05,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    syncTouch: false // Touch behält den nativen Schwung
  });

  let laeuft = true;

  function frame(zeit) {
    lenis.raf(zeit);
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  const anhalten = () => {
    if (!laeuft) return;
    lenis.stop();
    laeuft = false;
  };

  const fortsetzen = () => {
    if (laeuft) return;
    lenis.start();
    laeuft = true;
  };

  window.bbcScrollAnhalten = anhalten;
  window.bbcScrollFortsetzen = fortsetzen;

  /*
    Erkennt automatisch, wenn irgendetwas das Scrollen sperrt — egal ob
    unser eigenes Menü oder eine App, deren Klassennamen wir nicht kennen.
    Geprüft wird der tatsächliche Effekt (overflow gesperrt), nicht ein
    bestimmter Klassenname.
  */
  const scrollGesperrt = () => {
    const koerper = getComputedStyle(document.body).overflow;
    const wurzel = getComputedStyle(document.documentElement).overflow;
    return koerper === 'hidden' || wurzel === 'hidden';
  };

  const pruefen = () => (scrollGesperrt() ? anhalten() : fortsetzen());

  const beobachter = new MutationObserver(pruefen);
  beobachter.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  beobachter.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });

  // Sprungmarken weich anfahren
  document.addEventListener('click', (ereignis) => {
    const link = ereignis.target.closest('a[href^="#"]');
    if (!link) return;
    const ziel = link.getAttribute('href');
    if (!ziel || ziel === '#') return;
    const element = document.querySelector(ziel);
    if (!element) return;
    ereignis.preventDefault();
    lenis.scrollTo(element, { offset: -80 });
  });

  // Wenn die Systemeinstellung während der Sitzung umgestellt wird
  reduziert.addEventListener('change', (ereignis) => {
    if (ereignis.matches) {
      lenis.destroy();
      beobachter.disconnect();
    }
  });
})();
